<template>
    <div class="header">
        <div class="left"><span></span><label for="">{{status}}</label><label for="" class="h"></label><label for="">{{title}}</label></div>
        <div class="right">
          <span @click="exit()" v-if="errorStatus == 10"><label for=""></label>结束直播 </span>
        </div>
    </div>
</template>

<script>
import {endLive} from '@/api/home'
import { mapActions } from 'vuex'
import {removeCookie} from '@/common/js/units'
    export default {
        props: ['title', 'status', 'errorStatus'],
        // {
        //   title:{
        //     type:String,
        //     default:''
        //   },
        //   status:{
        //     type:String,
        //     default:''
        //   },
        //   exit: {
        //     type:Number,
        //     default: ''
        //   }
        // },
        data() {
          return {
          
          }
        },
        methods: {
          logout() {
            // this.$router.push('/login')
            // removeCookie('token')
          },
          exit() {
            this.$confirm('确定结束当前直播？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              this.setLoading(true)
              endLive({
                data: {innerid: this.$route.query.innerid},
                success: data => {
                  this.setLoading(false)
                  if(data.code == '000') {
                    this.$message.success('已结束直播')
                    setTimeout(() => {
                      location.reload()
                    }, 500)
                  } else {
                    this.$message.error(data.msg)
                  }
                },
                error: data => {
                  this.setLoading(false)
                  this.$message.error(data.msg)
                }
              })

            }).catch(() => {});
          },
          ...mapActions(['setLoading'])
        },
    }
</script>

<style  scoped lang="scss" >
.header{
  margin-bottom: 24px;
	height:50px;
  // background: url('../../../../public/pc/index_navbg.png');
  display: flex;
  justify-content: space-between;
  line-height: 50px;
  color: #303133;
  background: #fff;
  box-shadow:0px 1px 8px 0px rgba(0,18,41,0.1);
  -webkit-box-shadow:0px 1px 8px 0px rgba(0,18,41,0.1);
  -ms-box-shadow:0px 1px 8px 0px rgba(0,18,41,0.1);
  -moz-box-shadow:0px 1px 8px 0px rgba(0,18,41,0.1);
  -o-box-shadow:0px 1px 8px 0px rgba(0,18,41,0.1);
  .left{
    padding-left: 20px;
    span{
      display: inline-block;
      margin-right: 20px;
      width: 26px;
      height: 18px;
      vertical-align: middle;
      background: url('../../../../../common/images/liveing/live_logo.png') no-repeat;
      background-size: 26px 18px;
    }
    label{
      // vertical-align: sub;
      // margin-right: 16px;
    }
    .h{
      margin: 0 6px;
      width: 1px;
      height: 14px;
      display: inline-block;
      background: #303133;
      position: relative;
      top: 2px;
    }
  }
  .right{
    font-size: 14px;
    padding-right: 20px;
    span{
      // margin-left: 25px;
      color: #F56C6C;
      cursor: pointer;
    }
    span:nth-child(1){
      label{
          width: 14px;
          height: 14px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
          background: url('../../../../../common/images/liveing/set_end.png') no-repeat;
          background-position: center;
          background-size: 14px 14px;
      }
    }
  }
}
</style>